<div id="launcher-wr">
    <div id="spinner"></div>
    <div class="caption">Launching {{module}}</div>
</div>
